import React from "react";
import { AiOutlineWarning, AiOutlineGlobal } from "react-icons/ai";
import { MdVpnLock } from "react-icons/md";

const GeoRestrictionWarning = ({ availability, className = "" }) => {
	if (!availability || availability.available) {
		return null;
	}

	const getIcon = () => {
		switch (availability.restriction_reason) {
			case "VPN_DETECTED":
				return <MdVpnLock className="w-5 h-5 text-yellow-500" />;
			case "GEO_BLOCKED":
				return <AiOutlineGlobal className="w-5 h-5 text-red-500" />;
			case "LOCATION_UNKNOWN":
				return <AiOutlineWarning className="w-5 h-5 text-orange-500" />;
			default:
				return <AiOutlineWarning className="w-5 h-5 text-gray-500" />;
		}
	};

	const getBackgroundColor = () => {
		switch (availability.restriction_reason) {
			case "VPN_DETECTED":
				return "bg-yellow-50 border-yellow-200";
			case "GEO_BLOCKED":
				return "bg-red-50 border-red-200";
			case "LOCATION_UNKNOWN":
				return "bg-orange-50 border-orange-200";
			default:
				return "bg-gray-50 border-gray-200";
		}
	};

	const getTextColor = () => {
		switch (availability.restriction_reason) {
			case "VPN_DETECTED":
				return "text-yellow-800";
			case "GEO_BLOCKED":
				return "text-red-800";
			case "LOCATION_UNKNOWN":
				return "text-orange-800";
			default:
				return "text-gray-800";
		}
	};

	return (
		<div className={`p-3 rounded-lg border ${getBackgroundColor()} ${className}`}>
			<div className="flex items-start space-x-3">
				<div className="flex-shrink-0">{getIcon()}</div>
				<div className="flex-1">
					<p className={`text-sm font-medium ${getTextColor()}`}>
						{availability.restriction_reason === "VPN_DETECTED" && "VPN Detected"}
						{availability.restriction_reason === "GEO_BLOCKED" && "Not Available in Your Region"}
						{availability.restriction_reason === "LOCATION_UNKNOWN" &&
							"Location Verification Required"}
					</p>
					<p className={`text-sm mt-1 ${getTextColor()}`}>{availability.message}</p>
					{availability.user_location?.country_name && (
						<p className={`text-xs mt-2 ${getTextColor()}`}>
							Your location: {availability.user_location.country_name}
						</p>
					)}
				</div>
			</div>
		</div>
	);
};

export default GeoRestrictionWarning;
